import { render } from "./PopupWalletWithdraw.vue?vue&type=template&id=24945376&scoped=true"
import script from "./PopupWalletWithdraw.vue?vue&type=script&lang=js"
export * from "./PopupWalletWithdraw.vue?vue&type=script&lang=js"

import "./PopupWalletWithdraw.vue?vue&type=style&index=0&id=24945376&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24945376"]])

export default __exports__